import { render } from "./NotificationCheckSvg.vue?vue&type=template&id=7f7931dc"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__